/**
 * 네이버 지도 SDK 표준 컨트롤러.
 *
 * [data-fw-naver-map] 컨테이너에서 clientId/좌표를 읽어 SDK 를 동적 로드하고
 * 지도 + 마커 + 식장 이름 말풍선(InfoWindow) 렌더. clientId 미지정 시 skip.
 *
 * DOM 규약:
 *   <section data-section="venue" data-venue-name="{{ wedding.venue.name }}">
 *     <div data-fw-naver-map
 *          data-client-id="{{ naverMap.clientId }}"
 *          data-lat="{{ wedding.venue.lat }}"
 *          data-lng="{{ wedding.venue.lng }}"
 *          id="naverMap" style="width:100%;height:240px;"></div>
 *   </section>
 *
 * id 폴백: #naverMap. 좌표는 data-venue-lat/lng 도 fallback. 이름은 mapEl
 * 의 data-name 또는 부모 [data-venue-name] 섹션에서 폴백 조회.
 */
export const NAVER_MAP_CONTROLLER_SCRIPT = `
<script data-fw-naver-map-controller>
(function () {
  var mapEl = document.querySelector('[data-fw-naver-map]') || document.getElementById('naverMap');
  if (!mapEl) return;
  var clientId = mapEl.getAttribute('data-client-id');
  if (!clientId) return;
  var latRaw = mapEl.getAttribute('data-lat') || mapEl.getAttribute('data-venue-lat');
  var lngRaw = mapEl.getAttribute('data-lng') || mapEl.getAttribute('data-venue-lng');
  var LAT = parseFloat(latRaw || '');
  var LNG = parseFloat(lngRaw || '');
  if (isNaN(LAT) || isNaN(LNG)) return;

  var venueName = (mapEl.getAttribute('data-name') || mapEl.getAttribute('data-venue-name') || '').trim();
  if (!venueName) {
    var venueSection = mapEl.closest && mapEl.closest('[data-venue-name]');
    if (venueSection) venueName = (venueSection.getAttribute('data-venue-name') || '').trim();
  }

  if (mapEl.dataset.fwNaverMapInit) return;
  mapEl.dataset.fwNaverMapInit = '1';

  // 컨테이너에 명시 높이가 없으면 기본값 부여 (CSS 누락 방어)
  var rect = mapEl.getBoundingClientRect();
  if (!rect.height || rect.height < 10) {
    mapEl.style.minHeight = '240px';
    if (!mapEl.style.width) mapEl.style.width = '100%';
  }

  var s = document.createElement('script');
  s.src = 'https://oapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=' + encodeURIComponent(clientId);
  s.async = true;
  s.onload = function () {
    if (!window.naver || !window.naver.maps) return;
    var naver = window.naver;
    var center = new naver.maps.LatLng(LAT, LNG);
    var map = new naver.maps.Map(mapEl, {
      center: center, zoom: 16,
      draggable: true, scrollWheel: false, pinchZoom: true,
      disableDoubleClickZoom: true,
      zoomControl: false, mapDataControl: false, scaleControl: false,
    });
    var marker = new naver.maps.Marker({ map: map, position: center });
    if (venueName) {
      var safe = venueName.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
      var content = '<div style="padding:6px 14px;font-size:13px;font-weight:600;white-space:nowrap;color:#1a1a1a;background:#fff;border-radius:20px;box-shadow:0 2px 12px rgba(0,0,0,.15);letter-spacing:0.01em;">' + safe + '</div>';
      var info = new naver.maps.InfoWindow({
        content: content,
        borderWidth: 0,
        backgroundColor: 'transparent',
        anchorSize: new naver.maps.Size(0, 0),
        pixelOffset: new naver.maps.Point(0, -8),
      });
      info.open(map, marker);
    }
  };
  document.head.appendChild(s);
})();
</script>
`;
//# sourceMappingURL=naver-map.js.map